import React, { useState } from 'react';
import SlickSlider from 'react-slick';
import Slider from 'react-rangeslider';
import CurrencyFormat from 'react-currency-format';
import 'react-rangeslider/lib/index.css';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import './how-it-works.scss';

import slider1 from '../../images/slickslide-1.jpg';
import slider2 from '../../images/slickslide-2.jpg';
import slider3 from '../../images/slickslide-3.jpg';
import slider4 from '../../images/slickslide-4.jpg';
import slider5 from '../../images/slickslide-5.jpg';
import slider6 from '../../images/slickslide-6.jpg';
import { Container } from '@mui/material';

const HowItWorks = () => {
    const responsive = {
        0: {
            items: 1,
        },
        600: {
            items: 2,
        },
        1024: {
            items: 4,
        },
    };

    const [onePercent, setOnePercent] = useState(0);
    const [fivePercent, setFivePercent] = useState(0);
    const [state, setState] = useState(1000);
    const [range, setRange] = useState(0);
    const handleChange = (newstate) => {
        setState(newstate);

        let value = (state * range) / 100;
        setOnePercent(value);
        setFivePercent(value * 5);
    };
    const handleChange2 = (newstate) => {
        setRange(newstate);

        let value = (state * range) / 100;
        setOnePercent(value);
        setFivePercent(value * 5);
    };

    function Arrow(props) {
        let className = props.type === 'next' ? 'slick-next' : 'slick-prev';
        className += ' slick-arrow';
        const char = props.type === 'next'
            ? <i style={{ color: 'rgba(0,0,0,0.5)' }} className='fa-solid fa-angle-right'></i>
            : <i style={{ color: 'rgba(0,0,0,0.5)' }} className='fa-solid fa-angle-left'></i>;

        return (
            <button
                className={className}
                onClick={props.onClick}
                style={{ fontSize: 32 }}
            >
                {char}
            </button>
        );
    }

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 5000,
        nextArrow: <Arrow type="next" />,
        prevArrow: <Arrow type="prev" />,
    };

    return <Container
        className='how-it-works'
        maxWidth="md"
    >
        <div className="container">
            <div className="section page-title">
                <div className="page-title-container">
                    <h1>How it works</h1>
                </div>
            </div>

            <div className="slider-how-it-works">
                <SlickSlider {...settings}>
                    <div className="slider-how-it-works-item">
                        <LazyLoadImage src={slider1} />
                        <div className="slider-details">
                            <h5>Anyone Can earn</h5>
                            <p>As far as we’re concerned, if you use social media and produce your own content, you should be using Privaposts. Whether you’re uploading tutorials, tips, behind the scenes footage or just endless selfies, a lot of your followers would be willing to pay for them!</p>
                        </div>
                    </div>
                    <div className="slider-how-it-works-item">
                        <LazyLoadImage src={slider2} />
                        <div className="slider-details">
                            <h5>Subscribe to see more</h5>
                            <p>We all have profiles we just love to follow! Well wouldn't you be happy to pay a small subscription fee to see exclusive content and live streaming from the people you love? That's the beauty of Privaposts... The real fans are rewarded for their support!</p>
                        </div>
                    </div>
                    <div className="slider-how-it-works-item">
                        <LazyLoadImage src={slider3} />
                        <div className="slider-details">
                            <h5>Exclusive and uncensored</h5>
                            <p>Post and view exclusive, uncensored and premium content from all your favourite celebrities, influencers and content creators that is too explicit for Instagram, Facebook and YouTube!</p>
                        </div>
                    </div>
                    <div className="slider-how-it-works-item">
                        <LazyLoadImage src={slider4} />
                        <div className="slider-details">
                            <h5>We're safe and secure</h5>
                            <p>We've all read horror stories about security breaches on the internet and so we wanted to be sure taht we offer you the safest and securest platform possible. Sensitive information like your name and address are stored on separate secure servers and fully encrypted. Financial information, such as your bank account details and payment card are stored by our fully PCI compliant payment processors. We do not store or access this information, rather we hold a token (no actual data), which allows us to manage the information, once fully verified.</p>
                        </div>
                    </div>
                    <div className="slider-how-it-works-item">
                        <LazyLoadImage src={slider5} />
                        <div className="slider-details">
                            <h5>We're Mobiel Too!</h5>
                            <p>We know you're increasingly mobile... And so are we! We want you to be asble to take your followers with you, wherever you go. So whether you're uploading content or interacting with your followers, but be sure to use your mobile device and keep posting!</p>
                        </div>
                    </div>
                    <div className="slider-how-it-works-item">
                        <LazyLoadImage src={slider6} />
                        <div className="slider-details">
                            <h5>Become A referrer</h5>
                            <p>Are you webmaster, enterpreneur or social influencer with a high following? Then why not turn those followers into money in the bank with our new referral program. You receive 5% commission (LIFETIME!) on all income earned by users who join via your link. So join for free, post your referral link to your followers and then sit back, relax and watch your earning grow!</p>
                        </div>
                    </div>
                </SlickSlider>
            </div>

            <div className="fool-count-container">
                <div className="page-subheading-container">
                    <h4>How much could you earn?</h4>
                </div>
                <div className="fool-count">
                    <div className="fool-count-soc-container">
                        <h4>Number of followers?</h4>
                        <div className="fool-count-soc">
                            <a href="https://facebook.com" target="_blank">
                                <i className='fa-brands fa-facebook-f'></i>
                            </a>
                            <a href="https://twitter.com" target="_blank">
                                <i className='fa-brands fa-twitter'></i>
                            </a>
                            <a href="https://instagram.com" target="_blank">
                                <i className='fa-brands fa-instagram'></i>
                            </a>
                            <a href="https://snapchat.com" target="_blank">
                                <i className='fa-brands fa-snapchat'></i>
                            </a>
                        </div>
                    </div>
                    <div className="fool-count-rangeslider">
                        <span className="rangeslider-left-value">1,000</span>
                        <Slider min={1000} max={1000000} value={state} step={1000} onChange={handleChange} />
                        <span className="rangeslider-right-value">1,000,000</span>
                    </div>
                </div>
            </div>
            <div className="monthly-sub-price">
                <div className="page-subheading-container">
                    <h4>Monthly Subscription Price</h4>
                </div>
                <div className="monthly-sub-price-count">
                    <div className="monthly-sub-price-count-rangeslider">
                        <span className="rangeslider-left-value">$1</span>
                        <Slider min={1} max={100} value={range} onChange={handleChange2} />
                        <span className="rangeslider-right-value">$100</span>
                    </div>
                </div>
            </div>
            <div className="estimate-earning-container">
                <h3>
                    Your earnings would be between
                    {' '}
                    <span className="price1"><CurrencyFormat value={onePercent} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                    {' '}
                    and
                    {' '}
                    <span className="price2"><CurrencyFormat value={fivePercent} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                    {' '}
                    per month
                </h3>
                <p>
                    Based on
                    {' '}
                    <span className="price1-percentage">1%</span>
                    {' '}
                    and
                    {' '}
                    <span className="price2-percentage">5%</span>
                    {' '}
                    of your followers subscribing. On average 8% to 10% of our content creators' followers on social media will pay for exclusive content.
                </p>
            </div>
        </div>
    </Container>;
};

export default HowItWorks;
